import axios from "axios";
import { config_headers, URL_API, servicelist } from "../Config";

export const pP2Print = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios
                .post(URL_API(`${servicelist.P2Service}p_p2_print`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
